import axios from '@/plugins/axios'
import type { AxiosResponse } from 'axios'
import type { IServerResponse } from '@/models/IServerResponse'
import { IApiary } from '@/models/IApiary'

const resource = 'api/v1/apiary'

export default {
    getWeatherByIdApiary(idApiary: number): Promise<AxiosResponse<IServerResponse<any>>> {
        return axios.get(`${resource}/${idApiary}/weather`)
    },

    getApiaryChartData(idApiary: number, dateStart: string, dateEnd: string): Promise<AxiosResponse<IServerResponse<any>>> {
        return axios.get(`${resource}/${idApiary}/chart?date_start=${dateStart}&date_end=${dateEnd}`)
    },

    postAddApiary(apiary): Promise<AxiosResponse<IServerResponse<IApiary>>> {
        return axios.post(`${resource}`, apiary)
    },

    putUpdateApiary(apiary): Promise<AxiosResponse<IServerResponse<IApiary>>> {
        return axios.put(`${resource}/${apiary.id_apiary}`, apiary)
    },

    deleteApiary(idApiary: number): Promise<AxiosResponse<IServerResponse<any>>> {
        return axios.delete(`${resource}/${idApiary}`)
    },
}